import { render, staticRenderFns } from "./BankingDetailsStep.vue?vue&type=template&id=0af2cee8&scoped=true&"
import script from "./BankingDetailsStep.vue?vue&type=script&lang=js&"
export * from "./BankingDetailsStep.vue?vue&type=script&lang=js&"
import style0 from "./BankingDetailsStep.vue?vue&type=style&index=0&id=0af2cee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2cee8",
  null
  
)

export default component.exports